export const BASE_URL = import.meta.env.VITE_BASE_API_URL
export const TEST_URL = import.meta.env.VITE_TEST_API_URL

export const BASE_GATEWAY_URL = import.meta.env.VITE_BASE_API_GATEWAY_URL
export const TEST_GATEWAY_URL = import.meta.env.VITE_TEST_API_GATEWAY_URL

export const BASE_WSS_GATEWAY_URL = import.meta.env.VITE_BASE_WSS_API_GATEWAY_URL
export const TEST_WSS_GATEWAY_URL = import.meta.env.VITE_TEST_WSS_API_GATEWAY_URL

export const BASE_API_URL = `${import.meta.env.MODE === 'test' ? TEST_URL : BASE_URL}`
export const BASE_API_GATEWAY_URL = `${import.meta.env.MODE === 'test' ? TEST_GATEWAY_URL : BASE_GATEWAY_URL}`
export const BASE_API_WSS_GATEWAY_URL = `${import.meta.env.MODE === 'test' ? TEST_WSS_GATEWAY_URL : BASE_WSS_GATEWAY_URL}`

export const OIDC_AUTHORITY = import.meta.env.VITE_OIDC_AUTHORITY
export const OIDC_SESSION_STORAGE = `oidc.user:${OIDC_AUTHORITY}:arhiassistant-app`
export const OIDC_CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID
export const OIDC_API_CLIENT_ID = import.meta.env.VITE_OIDC_API_CLIENT_ID
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL

export const SENTRY_URL = import.meta.env.VITE_SENTRY_URL

export const LOGIN_URL = `auth/login`
export const REGISTRATION_URL = `auth/register`
export const VERIFY_EMAIL_URL = `auth/user_email_verify/complete`

export const PASSWORD_RESET_URL = `auth/user_password_reset/start`
export const PASSWORD_RESET_GET_TOKEN_URL = `auth/user_password_reset/get_token`
export const PASSWORD_RESET_COMPLETE_URL = `auth/user_password_reset/complete`
export const EMAIL_VERIFY_RESEND_CODE_URL = `email_verify/resend_code`

export const THREAD_URL = `collaboration_app/thread`
export const REPLY_URL = `collaboration_app/reply`
export const REPLY_SEARCH_URL = `collaboration_app/reply-search/search`
export const WALLET_URL = `wallet`
export const PROMOCODE_URL = `promocode/apply`

export const DEPOSIT_URL = `deposit`
export const RECURRING_PAYMENT_URL = 'recurring_payment'
export const STORAGE_TARIFFS_URL = 'storage_tariff'
export const STORAGE_TARIFF_USER_URL = 'storage_tariff_user'
export const BILLING_ADDED_URL = `billing/balance_increase`
export const BILLING_SPENT_URL = `billing/service_charge`

export const MODEL_URL = `ai/llm_model`
export const TOOL_AI_URL = `ai/llm_tool`
export const USER_AI_URL = `ai/user_ai_defaults`
export const ASSISTANT_URL = `assistant`
export const ASSISTANT_SUBSCRIPTIONS_URL = `paid_assistant`

export const WORKPLACE_URL = `collaboration_app/workplace`
export const RECORD_URL = `collaboration_app/record`
export const RECORD_STAGE_URL = `collaboration_app/record_stage`
export const STENOGRAPHY_URL = `collaboration_app/record_stenography`
export const MEMO_URL = `collaboration_app/memo`
export const MEMO_PROMPT_URL = `collaboration_app/memo_prompt`
export const MEET_URL = `collaboration_app/meeting`

export const PRESIGNED_GATEWAY_URL = `user_folder/file_object/presign_post`
export const EXTERNAL_GATEWAY_URL = `user_folder/external_upload`
export const USER_FOLDER_URL = `user_folder`
export const USER_FOLDER_FILES_URL = `user_folder/file_object`
export const TARIFF_URL = `tariff`
export const USER_TARIFF_URL = `user_tariff`
export const USER_REFERRAL_INFO = 'user_referral/info'
export const USER_REFERRAL = 'user_referral'
